var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ActivatedRoute } from '@angular/router';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'nexe... Remove this comment to see the full error message
import { biz } from 'nexedu-common';
import { SupervisorService, ViewService } from '../../services';
import { DetailView, UserValidator } from '../../interfaces';
var SupervisorComponent = /** @class */ (function (_super) {
    __extends(SupervisorComponent, _super);
    function SupervisorComponent(viewService, service, route) {
        var _this = _super.call(this, viewService, service, route, 'supervisor', UserValidator.newFormGroup(), false) || this;
        _this.deletePermission = 'remove';
        return _this;
    }
    SupervisorComponent.prototype.getValue = function () {
        return this.form.value;
    };
    SupervisorComponent.prototype.getDefaultDetails = function () {
        return {
            gender: biz.GENDERS.FEMALE
        };
    };
    SupervisorComponent.prototype.checkPermissions = function () {
        _super.prototype.checkPermissions.call(this);
        // overwrite permissions
        var isCurrentUser = this.viewService.isCurrentUser(this._id);
        this.isDeleteAllowed = !isCurrentUser && this.isDeleteAllowed;
        this.isForcePasswordAllowed = !isCurrentUser && !this.isCreate && this.viewService.isAllowed('tenant', 'force-member-password');
    };
    return SupervisorComponent;
}(DetailView));
export { SupervisorComponent };
